import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    padding-bottom: 4em;
`;
